(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('avm-prequalifications', {
            parent: 'admin',
            url: '/reports/avm-prequalifications?page&sort',
            reloadOnSearch: false,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'avmPrequalifications.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/avm-prequalifications/avm-prequalifications.html',
                    controller: 'AvmPrequalificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    var sortString = $stateParams.sort || 'createdDate,desc';
                    return {
                        page: PaginationUtil.parsePage($stateParams.page) || 1,
                        sort: sortString,
                        predicate: PaginationUtil.parsePredicate(sortString),
                        ascending: PaginationUtil.parseAscending(sortString)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avmPrequalifications');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
